import { useLayoutEffect, useState, useEffect } from 'react'
import { ReCaptchaProvider } from 'react-recaptcha-x'
import { BrowserRouter as Router, useLocation, Outlet } from 'react-router-dom'
import { createWeb3ReactRoot, Web3ReactProvider } from '@web3-react/core'
import { AliveScope } from 'react-activation'
import { sensorsInit } from 'hooks/useSensors'
import { NetworkContextName } from './constants/misc'
import getLibrary from 'utils/getLibrary'
import { ToastContainer } from 'react-toastify'
import { Box, styled } from '@mui/material'
// import { useGlobalAnnouncement, useCabitalModalToggle } from 'state/application/hooks'
// import { useUser } from 'state/user/hooks'
import CloseIcon from 'assets/images/svg/common/close-gray.svg'
import ToastErrorIcon from 'assets/images/svg/common/toast-error.svg'
import ToastSuccessIcon from 'assets/images/svg/common/toast-success.svg'
import ToastInfoIcon from 'assets/images/svg/common/toast-info.svg'
import CustomizeRoutes from 'routers'
import { GA_KEY } from 'config'
import HeaderMobile from 'components/HeaderMobile'
import WebSocket from 'components/WebSocket'
import Cookies from 'js-cookie'
import { v4 as uuid } from 'uuid'
import Bigdata from 'services/bigdata'
import FlutterAppData from 'services/flutterAppConnection'
import Web3ReactManager from 'components/Web3ReactManager'
import Header from 'components/Header'
import Footer from 'components/Footer'
import InsufficientBalanceModal from 'components/InsufficientBalanceModal'

import './sdk/bd'
import { useAppDispatch } from 'state/hooks'
import { useUser } from 'state/user/hooks'
import { setProfileInfo, setUserAssets } from 'state/user/actions'
import { DownloadHeaderH5 } from 'components/DownloadYeeha/DownloadHeaderH5'

if (!Cookies.get('cid')) {
  const _uuid = 'c_' + uuid().replaceAll('-', '').slice(0, 19)
  Cookies.set('cid', _uuid)
}

new Bigdata().requisite()

const Web3ProviderNetwork = createWeb3ReactRoot(NetworkContextName)
if (!!window.ethereum) {
  window.ethereum.autoRefreshOnNetworkChange = false
}

sensorsInit()

const ScrollToTop = ({ children }: { children: JSX.Element }) => {
  const location = useLocation()
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [location.pathname])
  return children
}

const InAppEnvLoading = styled(Box)`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
`

export default function App() {
  const user = useUser()
  const dispatch = useAppDispatch()
  const [flutterLoading, setFlutterLoading] = useState(false)
  const isAppEnv = FlutterAppData.isInAppEnv()
  // insert session referrer
  const referrer = document.referrer
  window.sessionStorage.setItem('referrer_url', referrer)

  useEffect(() => {
    if (isAppEnv) {
      setFlutterLoading(true)
      FlutterAppData.start().then(() => {
        setFlutterLoading(false)
        if (FlutterAppData.getAppData()) {
          dispatch(setProfileInfo())
          dispatch(setUserAssets())
        }
      })
    }
  }, [isAppEnv, dispatch])
  if (flutterLoading) {
    return <InAppEnvLoading />
  }
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <Web3ProviderNetwork getLibrary={getLibrary}>
        <Web3ReactManager>
          <ReCaptchaProvider siteKeyV3={GA_KEY} langCode="en" hideV3Badge={true}>
            <Router>
              <ToastContainer
                position="top-right"
                closeOnClick={true}
                icon={
                  <>
                    <img className="info" src={ToastInfoIcon} alt=""></img>
                    <img className="error" src={ToastErrorIcon} alt=""></img>
                    <img className="success" src={ToastSuccessIcon} alt=""></img>
                  </>
                }
                closeButton={({ closeToast }: { closeToast: any }) => (
                  <img className="toast-close" src={CloseIcon} alt="" onClick={closeToast}></img>
                )}
                hideProgressBar={true}
                autoClose={2500}
              />
              <DownloadHeaderH5></DownloadHeaderH5>
              <Header classNameString="smShowNo" />
              <HeaderMobile classNameString="smShow"></HeaderMobile>
              <WebSocket />
              <ScrollToTop>
                <AliveScope>
                  <CustomizeRoutes></CustomizeRoutes>
                </AliveScope>
              </ScrollToTop>
              {<Footer />}
              {user && <InsufficientBalanceModal />}
            </Router>
            <Outlet />
          </ReCaptchaProvider>
        </Web3ReactManager>
      </Web3ProviderNetwork>
    </Web3ReactProvider>
  )
}
